/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .directive('accQuotaUtilization', [function() {
        return {
            template: '<span translate="%{used_space} of %{available_space} used"\
                        translate-values="{used_space: \'{{account[\'sync_and_share_content\'][\'used_space\'] | fileSize:\'byte\':1}}\', available_space: \'{{account.quota | fileSize:\'byte\':0}}\'}">\
                       </span>'
        }
    }]);